<template>
  <div class="indextitle">
    <div class="title">
        <a href="javascript:void(0);" class="active">
        <p class="name"><slot name="title"></slot></p>
        <span><p><slot name="eng"></slot></p></span>
        </a>
    </div>

    <div class="more">
        <slot name="more"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'indexTitle'
}
</script>

<style lang="less">
.indextitle{
    height:50px;
    margin-bottom: 15px;
    .title{
        float:left;
        .name{
            font-weight: bold;
            font-size: 24px;
            color: #333333;
            line-height: 33px;
        }
        span{
            display:block;
            position:relative;
            padding-left: 26.5px;
            &::before{
                position: absolute;
                content: "";
                left: 0;
                bottom: 5.3px;
                width: 20px;
                height: 2px;
                background: #0E6BB6;
            }
            p{
                font-size: 11px;
                color: rgb(153, 153, 153);
                line-height: 17px;
                margin-left: 12px;
            }
        }
    }
    .more{
        float:right;
        margin-top:17px;
        a{
            font-size: 14px;
            color: rgb(14, 107, 182);
            line-height: 17px;
            padding-right: 8px;
            cursor: pointer;
            background: url(@/assets/icon1.png) right center / 4px 7px no-repeat;
        }
    }
}
</style>
